module.exports = __webpack_public_path__ + "img/y_p3_y5.10d5cca8.png";